import scrollTo from 'gatsby-plugin-smoothscroll';
import PropTypes from 'prop-types';
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { animated, useSpring } from 'react-spring';
import bgImageMobile from '../images/bgPhone.jpg';
import dividerColored from '../images/divider-colored.svg';
import divider from '../images/divider-white.svg';
import '../styles/global.scss';
import LetsTalk from './LetsTalk';

const Hero = ({
  title,
  subtitle,
  bgImage,
  isHomePage,
  isAboutUs,
  isProducts,
  aboutUsClass,
  aboutUsData,
  isLetsTalk,
  isCareers,
  isBlog,
}) => {
    const calc = (x, y) => [
      -(y - window.innerHeight / 2) / 20,
      (x - window.innerWidth / 2) / 20,
      1.1,
    ];
  
  const trans = (x, y, s) =>
    `perspective(3200px) rotateX(${x}deg)  scale(${s})`;
  const [props1, set1] = useSpring(() => ({
    xys: [0, 0, 1],
    config: { mass: 20, tension: 1200, friction: 30 },
  }));
  const [props2, set2] = useSpring(() => ({
    xys: [0, 0, 1],
    config: { mass: 20, tension: 1200, friction: 30 },
  }));
  const [props3, set3] = useSpring(() => ({
    xys: [0, 0, 1],
    config: { mass: 20, tension: 1200, friction: 30 },
  }));
  const [props4, set4] = useSpring(() => ({
    xys: [0, 0, 1],
    config: { mass: 20, tension: 1200, friction: 30 },
  }));
  const [props5, set5] = useSpring(() => ({
    xys: [0, 0, 1],
    config: { mass: 20, tension: 1200, friction: 30 },
  }));
  const [props6, set6] = useSpring(() => ({
    xys: [0, 0, 1],
    config: { mass: 20, tension: 1200, friction: 30 },
  }));

  const [isModal, setModal] = React.useState({ active: false, content: '' });
  const isPhone = useMediaQuery({ query: '(max-width: 768px)' });

  return (
    <React.Fragment>
      <div
        style={
          isBlog
            ? {
                background: `linear-gradient(to bottom, #000, rgba(0, 0, 0, 0.4)), url(${bgImage}) no-repeat center center`,
                backgroundSize: 'cover',
                // BgPosition Top 👇🏼
                backgroundPosition: 'top',
                mixBlendMode: 'multiply',
              }
            : isHomePage || isProducts
            ? {
                background: `linear-gradient(to bottom, #111, rgba(0, 0, 0, 0.001)), url(${bgImage}) no-repeat center center`,
                backgroundSize: 'cover',
                // BgPosition Top 👇🏼
                backgroundPosition: 'top',
                mixBlendMode: 'multiply',
              }
            : isPhone
            ? {
                background: `linear-gradient(to bottom, #111, rgba(0, 0, 0, 0.001)), url(${bgImageMobile}) no-repeat center center`,
                backgroundSize: 'cover',
                // BgPosition Top 👇🏼
                backgroundPosition: 'top',
                mixBlendMode: 'multiply',
              }
            : {
                background: `url(${bgImage}) no-repeat center center`,
                width: '100vw',
                height: '100vh',
                // BgPosition Top 👇🏼
                backgroundPosition: 'top',
                backgroundSize: 'cover',
              }
        }
        className='Hero'
      >
        <section className={`hero is-fullheight ${aboutUsClass}`}>
          <div
            className={`hero-body ${aboutUsClass}`}
            style={{ position: 'relative' }}
          >
            <div
              className={`container  ${aboutUsClass} ${
                isHomePage && isProducts ? 'has-text-centered' : ''
              }`}
            >
              {isHomePage && isProducts && (
                <React.Fragment>
                  <img src={divider} alt='divider' />
                  <p
                    className='title animate__animated animate__fadeInDown animate__delay-0.4s'
                    style={{ color: '#fff' }}
                  >
                    {title}
                  </p>

                  <p className='subtitle animate__animated animate__fadeIn animate__delay-1s'>
                    {subtitle}
                  </p>
                </React.Fragment>
              )}
              {isAboutUs && isPhone && (
                <React.Fragment className='has-text-centered'>
                  <center>
                    <img src={divider} alt='divider' />
                  </center>
                  <p
                    className='title animate__animated animate__fadeInDown'
                    style={{ color: '#fff' }}
                  >
                    {title}
                  </p>

                  <p className='subtitle animate__animated animate__fadeIn animate__delay-1s'>
                    {subtitle}
                  </p>
                </React.Fragment>
              )}
              {isBlog && isHomePage && (
                <React.Fragment>
                  <p
                    className='title-blog animate__animated animate__fadeInDown'
                    style={{
                      color: '#fff',
                      marginTop: '60vh',
                      float: 'left',
                      marginLeft: 65,
                      paddingLeft: '0',
                    }}
                  >
                    <img src={dividerColored} alt='divider' />
                    <br />
                    {title}
                  </p>

                  <p
                    className='subtitle-blog animate__animated animate__fadeIn animate__delay-0.9s'
                    style={{ float: 'left', marginLeft: 65 }}
                  >
                    {subtitle}
                  </p>
                </React.Fragment>
              )}
              {isAboutUs && !isPhone && (
                <React.Fragment>
                  <div className='row-h' style={{ width: '100vw' }}>
                    <animated.div
                      style={{
                        transform: props1.xys.interpolate(trans),
                        zIndex: 1,
                        marginLeft: 20,
                      }}
                      className='col-h aboutUsColH'
                    >
                      <p
                        style={{
                          zIndex: 1,
                          fontSize: '12px',
                          fontFamily: 'Muli',
                        }}
                      >
                        {aboutUsData.row1[0]}
                      </p>
                      {aboutUsData.row1[1]}
                    </animated.div>
                    <animated.div
                      style={{
                        transform: props2.xys.interpolate(trans),
                        marginLeft: '18vw',
                        zIndex: 1,
                      }}
                      className='col-h aboutUsColH'
                    >
                      <p style={{ fontSize: '13px', fontFamily: 'Muli' }}>
                        {aboutUsData.row2[0]}
                      </p>
                      {aboutUsData.row2[1]}
                    </animated.div>
                    <animated.div
                      style={{
                        transform: props3.xys.interpolate(trans),
                        zIndex: 1,
                        marginLeft: '34vw',
                      }}
                      className='col-h aboutUsColH'
                    >
                      <p style={{ fontSize: '13px', fontFamily: 'Muli' }}>
                        {aboutUsData.row3[0]}
                      </p>
                      {aboutUsData.row3[1]}
                    </animated.div>
                    <animated.div
                      style={{
                        transform: props4.xys.interpolate(trans),
                        zIndex: 1,
                        marginLeft: '51vw',
                      }}
                      className='col-h aboutUsColH'
                    >
                      <p style={{ fontSize: '13px', fontFamily: 'Muli' }}>
                        {aboutUsData.row4[0]}
                      </p>
                      {aboutUsData.row4[1]}
                    </animated.div>{' '}
                    <animated.div
                      style={{
                        transform: props5.xys.interpolate(trans),
                        zIndex: 1,
                        marginLeft: '68vw',
                      }}
                      className='col-h aboutUsColH'
                    >
                      <p style={{ fontSize: '13px', fontFamily: 'Muli' }}>
                        {aboutUsData.row5[0]}
                      </p>
                      {aboutUsData.row5[1]}
                    </animated.div>
                    <animated.div
                      style={{
                        transform: props6.xys.interpolate(trans),
                        zIndex: 1,
                        marginLeft: '85vw',
                      }}
                      className='col-h aboutUsColH'
                    >
                      <p style={{ fontSize: '13px', fontFamily: 'Muli' }}>
                        {aboutUsData.row6[0]}
                      </p>
                      {aboutUsData.row6[1]}
                    </animated.div>
                    <animated.div
                      className='col-h'
                      onMouseMove={({ clientX: x, clientY: y }) =>
                        set1({ xys: calc(x, y) })
                      }
                      onMouseLeave={() => set1({ xys: [0, 0, 1] })}
                      style={{
                        maxHeight: '100vh',
                        mixBlendMode: 'multiply',
                        backgroundColor: 'rgb(115, 97, 111)',
                      }}
                    ></animated.div>
                    <animated.div
                      className='col-h'
                      onMouseMove={({ clientX: x, clientY: y }) =>
                        set2({ xys: calc(x, y) })
                      }
                      onMouseLeave={() => set2({ xys: [0, 0, 1] })}
                      style={{
                        height: '100vh',
                        mixBlendMode: 'multiply',
                        backgroundColor: 'rgb(232, 132, 108)',
                      }}
                    ></animated.div>
                    <animated.div
                      className='col-h'
                      onMouseMove={({ clientX: x, clientY: y }) =>
                        set3({ xys: calc(x, y) })
                      }
                      onMouseLeave={() => set3({ xys: [0, 0, 1] })}
                      style={{
                        maxHeight: '100vh',
                        mixBlendMode: 'multiply',
                        backgroundColor: 'rgb(23, 82, 142)',
                      }}
                    ></animated.div>
                    <animated.div
                      className='col-h'
                      onMouseMove={({ clientX: x, clientY: y }) =>
                        set4({ xys: calc(x, y) })
                      }
                      onMouseLeave={() => set4({ xys: [0, 0, 1] })}
                      style={{
                        maxHeight: '100vh',
                        mixBlendMode: 'multiply',
                        backgroundColor: 'rgb(229, 76, 75)',
                      }}
                    ></animated.div>
                    <animated.div
                      className='col-h'
                      onMouseMove={({ clientX: x, clientY: y }) =>
                        set5({ xys: calc(x, y) })
                      }
                      onMouseLeave={() => set5({ xys: [0, 0, 1] })}
                      style={{
                        maxHeight: '100vh',
                        mixBlendMode: 'multiply',
                        backgroundColor: 'rgb(118, 158, 151)',
                      }}
                    ></animated.div>
                    <animated.div
                      className='col-h'
                      onMouseMove={({ clientX: x, clientY: y }) =>
                        set6({ xys: calc(x, y) })
                      }
                      onMouseLeave={() => set6({ xys: [0, 0, 1] })}
                      style={{
                        maxHeight: '100vh',
                        mixBlendMode: 'multiply',
                        backgroundColor: 'rgb(23, 124, 128)',
                      }}
                    ></animated.div>
                  </div>
                </React.Fragment>
              )}
              {isHomePage && isProducts && !isLetsTalk && (
                <div
                  className='button animate__animated animate__fadeInDown'
                  onClick={() =>
                    setModal({ content: 'is-active', active: true })
                  }
                >
                  <span className='button-text'>Interested?</span>
                </div>
              )}
              {isCareers && (
                <div className='button' onClick={() => scrollTo('#some-id')}>
                  <span className='button-text'>Openings</span>
                </div>
              )}
            </div>
          </div>
        </section>
        {isModal.active && <LetsTalk active={isModal} setModal={setModal} />}
      </div>
    </React.Fragment>
  );
};

Hero.propTypes = {
  bgImage: PropTypes.any,
  isAboutUs: PropTypes.bool,
  isHomePage: PropTypes.bool,
  isProducts: PropTypes.bool,
  subtitle: PropTypes.any,
  title: PropTypes.any,
};

export default Hero;
